import Modal from "react-bootstrap/Modal";
import { ChatFill } from "react-bootstrap-icons";
import ButtonLink from "components/Links/ButtonLink";
import * as React from 'react';
export default {
  Modal,
  ChatFill,
  ButtonLink,
  React
};